import { Link } from 'react-router-dom';
import { PRIVACY_PATH, TERMS_PATH } from '../legal/legalRoutes';
import { DEMO_URL } from '../signup/SignupLayout';
import logoUrl from './rosterpilot-logo.webp';
import './MarketingChrome.css';

/**
 * rosterpilot.com's header and footer, rebuilt for the web app's public pages (`/pricing`,
 * `/terms`, `/privacy`) so a coach who clicks through from the marketing site does not notice they
 * changed sites. The markup and links copy `marketing/index.html` (`.hdr` and `.ftr`); the logo is
 * the same image file. If the site's header or footer changes, change these too.
 *
 * Links to marketing pages are absolute: these pages are served by the web app, not the marketing
 * site. The footer's Privacy Policy and Terms of Service are the exception: they go to the app's own
 * `/privacy` and `/terms` (`features/legal`), which render the marketing site's legal text, so a
 * coach reading them stays on one site. Login stays in the app (`/login`), which is where the
 * marketing site's Login link goes as well. Schedule a demo goes straight to the booking page
 * (`DEMO_URL`), the one the site's own demo button ends at, rather than through the site's `#demo`
 * section.
 */

/** The marketing site's canonical origin (rosterpilot.com redirects here). */
export const MARKETING_SITE_URL = 'https://www.rosterpilot.com/';

export const MarketingHeader = () => (
  <header className="mk-hdr">
    <div className="mk-wrap mk-hdr__in">
      <a className="mk-hdr__logo" href={MARKETING_SITE_URL}>
        <img src={logoUrl} alt="RosterPilot home" width={285} height={58} />
      </a>
      <div className="mk-hdr__act">
        <Link className="mk-hdr__login" to="/login" data-testid="pricing-login">
          Login
        </Link>
        <a className="mk-btn mk-btn--primary" href={DEMO_URL}>
          Schedule a demo
        </a>
      </div>
    </div>
  </header>
);

export const MarketingFooter = () => (
  <footer className="mk-ftr">
    <div className="mk-wrap mk-ftr__in">
      <a className="mk-ftr__logo" href={MARKETING_SITE_URL}>
        <img src={logoUrl} alt="RosterPilot home" width={285} height={58} />
      </a>
      <nav aria-label="Legal">
        <Link to={PRIVACY_PATH}>Privacy Policy</Link>
        <Link to={TERMS_PATH}>Terms of Service</Link>
        <Link to="/login">Login</Link>
      </nav>
      <small>&copy; {new Date().getFullYear()} RosterPilot</small>
    </div>
  </footer>
);
